import { Element } from "@xmpp/xml"
import { PinnedMessage } from "../api/xeps/PinnedMessages"
import { MessageType } from "../reducers/messagesSlice"
import MessageParser from "./messageParser"

export type PinnedMessageEvent =
  | { from: string; type: "create"; pinned: PinnedMessage }
  | { from: string; type: "retract"; id: string }

class PinnedMessageEventParser {
  static parse(stanza: Element): PinnedMessageEvent | undefined {
    const node = stanza
      .getChild("event")
      ?.getChildByAttr("node", "urn:slickshift:message-pinning")

    if (!node) return

    const from = stanza.getAttr("from") as string

    if (node.getChild("item")) {
      const item = node.getChild("item")!
      const pinned = item.getChild("pinned")
      if (!pinned) return

      const message = pinned?.getChild("message") as Element
      const body = message?.getChild("body") as Element
      const messageId = message.getChild("stanza-id") as Element
      const at = pinned?.getChild("at") as Element
      const ttl = pinned?.getChild("ttl") as Element
      return {
        from: from,
        type: "create",
        pinned: {
          itemId: item.attr("id") as string,
          at: new Date(at.getText()).getTime(),
          ttl: parseInt(ttl.getText(), 10),
          message: {
            id: messageId.attr("id") as string,
            from: message.attr("from") as string,
            to: message.attr("to") as string,
            type: message.attr("type") as MessageType,
            body: body.getText() as string,
            url: MessageParser.url(message),
          },
        },
      }
    } else if (node.getChild("retract")) {
      return {
        from: "from",
        type: "retract",
        id: node.getChild("retract")?.getAttr("id"),
      }
    }
  }
}

export default PinnedMessageEventParser
